import { Typography } from "@shared/ui.primitives";
import React from "react";

import type { ProductCardDataType } from "./types";

type Props = {
  product: Pick<ProductCardDataType, "productName">;
  textOverflow?: "clip" | "ellipsis" | "fade" | "initial" | "inherit" | "unset";
};

export const HorizontalProductCardProductName: React.FC<Props> = ({
  product,
  textOverflow
}) => {
  if (!product.productName) return null;
  return (
    <Typography
      variant="product-sm"
      colour="primary-medium"
      overflow={textOverflow}
      whiteSpace="nowrap"
    >
      {product.productName}
    </Typography>
  );
};
